module.exports = __webpack_public_path__ + "img/icon_footer_fantasy_selected.c021e528.png";